<script setup lang="ts">
import { copyToClipboard } from "../../utils/GeneralUtils.ts";
import Button from "primevue/button";
import { DirectLink, Participant, Project, Trainer } from "../../types/PersologOnlineTypes.ts";
import ParticipantEmailButton from "../projects/participant-actions/ParticipantEmailButton.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
    recipient: {
        type: Object as () => Participant,
        required: true,
    },
    sender: {
        type: Object as () => Trainer,
        required: true,
    },
    project: {
        type: Object as () => Project,
        required: true,
    },
    directLink: {
        type: Object as () => DirectLink | null,
        default: null,
    },
});
</script>

<template>
    <div class="input-container">
        <label for="email_input_address" class="link-label">{{ t("common.email-address") }}:</label>
        <div class="input-field">
            <InputText id="email_input_address" class="mr-1 md:w-7/12 w-2/3" :value="recipient?.email" disabled />
            <Button
                severity="secondary"
                class="mr-1"
                icon="pi pi-copy"
                @click="copyToClipboard(recipient?.email as string)"
                :aria-label="t('accessibility.buttons.copy')"
            ></Button>
            <ParticipantEmailButton
                :participant="recipient"
                :project="project"
                :trainer="sender"
                :direct-link="directLink"
                context="details"
            />
        </div>
    </div>
</template>

<style>
.input-container {
    display: flex !important;
    flex-direction: column !important;
    align-items: left;

    .input-field {
        flex-direction: row !important;
    }
}

.link-label {
    font-size: 12px;
    color: #7e868d;
}
</style>
